import { CheckoutErrorName, ErrorContext } from '@/types/checkout';

import { CHECKOUT_ERRORS, DEFAULT_ERROR_MESSAGE } from '@/constants/checkout';
import { ValueOf } from '@/lib/tsutils';

const generateUnknownErrorMessage = (e: unknown): string => `An unknown error occurred: ${JSON.stringify(e)}`;
const generateErrorMessageFromError = (e: unknown): string =>
  e instanceof Error ? e.message : generateUnknownErrorMessage(e);

class CheckoutErrorObj extends Error {
  name: CheckoutErrorName;

  displayMessage?: string;

  ctx: ValueOf<ErrorContext>;

  constructor(name: CheckoutErrorName, message: string, displayMessage?: string, ctx?: ErrorContext, cause?: Error) {
    super(message, cause ? { cause } : {});
    this.name = name;
    const { displayMessage: knownDisplayMessage, ctx: knownCtx } = CHECKOUT_ERRORS[name] || {};
    this.displayMessage = displayMessage || knownDisplayMessage || DEFAULT_ERROR_MESSAGE;
    const defaultContext: ErrorContext = 'checkout';
    this.ctx = knownCtx || ctx || defaultContext;
  }
}

export default CheckoutErrorObj;
export { generateUnknownErrorMessage, generateErrorMessageFromError };
